import { render, staticRenderFns } from "./logo-header.vue?vue&type=template&id=541d20a2&"
import script from "./logo-header.vue?vue&type=script&lang=js&"
export * from "./logo-header.vue?vue&type=script&lang=js&"
import style0 from "./logo-header.vue?vue&type=style&index=0&id=541d20a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports